module.exports = __webpack_public_path__ + "img/secret-ciec.92d387a8.svg";